import { render, staticRenderFns } from "./certificate-categories.vue?vue&type=template&id=6655ddd9&scoped=true&"
import script from "./certificate-categories.ts?vue&type=script&lang=ts&"
export * from "./certificate-categories.ts?vue&type=script&lang=ts&"
import style0 from "./certificate-categories.scss?vue&type=style&index=0&id=6655ddd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655ddd9",
  null
  
)

export default component.exports